require('./_set-species')('Array');


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/es6.array.species.js
 ** module id = 281
 ** module chunks = 0
 **/